import React from 'react';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaEnvelope,
  FaPhone,
} from 'react-icons/fa';
import appStoreBadge from '../assets/images/appstore.svg';
import googlePlayBadge from '../assets/images/googleplay.svg';
import berymoLogo from '../logo.svg';
import '../styles/Footer.css';
import { useLanguage } from '../context/LanguageContext';

function Footer() {
  const { t } = useLanguage();
  const tf = t.footer;

  const handleEmailClick = (e) => {
    e.preventDefault();
    const to = 'support@berymo.com';
    const subject = encodeURIComponent('Support Request');
    const body = encodeURIComponent(
      'Hello Berymo Support Team,\n\nI need assistance with:\n\nThank you!'
    );
    const gmailUrl = `https://mail.google.com/mail/u/0/?view=cm&fs=1&tf=cm&to=${to}&su=${subject}&body=${body}`;
    const newWindow = window.open(gmailUrl, '_blank', 'noopener,noreferrer,width=800,height=600');
    if (newWindow) newWindow.focus();
  };

  return (
    <footer className="footer">
      <div className="footer-inner">

        <img src={berymoLogo} alt="Berymo" className="footer-brand-logo" />

        <div className="footer-columns">
          <div className="footer-column">
            <h4>{tf.riderSection}</h4>
            <ul>
              <li><a href="/Rider">{tf.overview}</a></li>
              <li><a href="https://play.google.com/store/apps/details?id=com.berymoflat&pli=1">{tf.signUpToRide}</a></li>
              <li><a href="/Safety">{tf.safety}</a></li>
              <li><a href="/Help">{tf.help}</a></li>
              <li><a href="/FindaCity">{tf.findCity}</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>{tf.driverSection}</h4>
            <ul>
              <li><a href="/driver">{tf.overview}</a></li>
              <li><a href="https://apps.apple.com/us/app/berymo-driver/id1440035432">{tf.signUpToDrive}</a></li>
              <li><a href="/DiverSafety">{tf.driverSafety}</a></li>
              <li><a href="/Help">{tf.help}</a></li>
              <li><a href="/FindaCity">{tf.findCity}</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>{tf.businessSection}</h4>
            <ul>
              <li><a href="/">{tf.overview}</a></li>
              <li><a href="https://place.berymo.com/#/login">{tf.signIn}</a></li>
              <li><a href="https://place.berymo.com/#/signup">{tf.signUp}</a></li>
              <li><a href="/BecomeaPartnerPlace">{tf.becomePartner}</a></li>
              <li><a href="/PackageDelivery">{tf.packageDelivery}</a></li>
              <li><a href="/dining-terms">{tf.diningTerms}</a></li>
            </ul>
          </div>

          <div className="footer-column">
            <h4>{tf.berymoSection}</h4>
            <ul>
              <li><a href="/Aboutus">{tf.aboutUs}</a></li>
              <li><a href="https://medium.com/berymo">{tf.news}</a></li>
              <li><a href="/Careers">{tf.careers}</a></li>
              <li><a href="/Legal">{tf.legal}</a></li>
              <li><a href="/Cities">{tf.cities}</a></li>
            </ul>
          </div>

          <div className="footer-column footer-column--social">
            <h4>{tf.socialSection}</h4>
            <div className="footer-social-icons">
              <a href="https://www.linkedin.com/company/berymo/about/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedinIn /></a>
              <a href="https://www.instagram.com/berymoapp/" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
              <a href="https://www.facebook.com/berymoapp" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
              <a href="https://x.com/i/flow/login?redirect_after_login=%2Fberymoapp" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter /></a>
            </div>
            <div className="footer-app-badges">
              <a href="https://apps.apple.com/us/app/berymo/id1440035432" target="_blank" rel="noopener noreferrer">
                <img src={appStoreBadge} alt="Download on the App Store" className="app-badge" />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.berymoflat&pli=1" target="_blank" rel="noopener noreferrer">
                <img src={googlePlayBadge} alt="Get it on Google Play" className="app-badge" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="footer-bottom">
          <p className="footer-disclaimer">{tf.disclaimer}</p>
          <div className="footer-bottom-row">
            <div className="footer-contact">
              <span className="contact-item">
                <FaEnvelope className="contact-icon" />
                <a href="#" onClick={handleEmailClick}>support@berymo.com</a>
              </span>
              <span className="contact-item">
                <FaPhone className="contact-icon" />
                <a href="tel:+18664237966">(1-866 4 BERYMO)</a>
              </span>
            </div>
            <ul className="footer-list">
              <li><a href="/Legal">{tf.privacy}</a></li>
              <li><a href="/TermsofUse">{tf.termsOfUse}</a></li>
              <li><a href="/Accessibility">{tf.accessibility}</a></li>
            </ul>
          </div>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
